// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type * as BrokerageTypes from '@shared/data-access/types/brokerage-types';

const NAME_FIELDS = [
  'first_name',
  'second_name',
  'first_surname',
  'second_surname',
] as const;

/**
 * Builds the body from the invite-client form. Only `email` is required; blank name
 * parts are omitted.
 */
export const buildCreateClientBody = (
  formData: FormData,
): BrokerageTypes.CreateClient => {
  const optionalField = (field: string) =>
    (formData.get(field) as string | null)?.trim() || undefined;

  return NAME_FIELDS.reduce<BrokerageTypes.CreateClient>(
    (body, field) => ({ ...body, [field]: optionalField(field) }),
    { email: ((formData.get('email') as string | null) ?? '').trim() },
  );
};
